/* ==========================================================================
   TRADA - Carrito: recomendaciones para envío gratis, cambio de talla/color,
   confirmaciones y medición. No modifica theme.js: usa la misma Cart API y
   Section Rendering API y observa los re-render del carrito.

   Medición: Shopify.analytics.publish (eventos personalizados del Web Pixels
   Manager, respeta el consentimiento de la tienda). Solo IDs de producto y
   variante, nunca datos personales. AddToCart, InitiateCheckout y Purchase
   ya los emiten Shopify/Meta/TikTok: aquí NO se vuelven a disparar.
   Los productos agregados desde recomendaciones llevan la propiedad oculta
   _origen=recomendacion-carrito, visible en el pedido del admin.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ORIGIN = 'recomendacion-carrito';
  var cache = {};
  var viewedSets = {};
  var busy = false;

  function qs(s, el) { return (el || document).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* la medición nunca bloquea la compra */ }
  }

  function readState(scope) {
    var el = qs('[data-cart-state]', scope);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Igual que el filtro money_without_trailing_zeros + código de moneda.
  function money(cents, state) {
    var n = cents / 100;
    var whole = cents % 100 === 0;
    var amount = n.toLocaleString('es-MX', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    });
    var fmt = (state && state.moneyFormat) || '${{amount}}';
    var out = fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
    var iso = (state && state.currency) || 'MXN';
    if (out.indexOf(iso) === -1) out += ' ' + iso;
    return out;
  }

  function optionLabel(name) {
    if (/^\s*[\d.,]+\s*$/.test(name)) return 'Talla'; // nombres de opción que quedaron como precio
    return name;
  }

  function isDefaultOnly(options) {
    return !options || options.length === 0 ||
      (options.length === 1 && (options[0].name === 'Title' || options[0].name === 'Título'));
  }

  function sentence(text, fallback) {
    var t = String(text || fallback || '').trim().replace(/[.\s]+$/, '');
    return t ? t + '.' : '';
  }

  function notice(message) {
    qsa('[data-cart-notice]').forEach(function (el) {
      el.textContent = message;
      el.hidden = false;
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.hidden = true; }, 4000);
    });
  }

  function postJSON(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) { return { ok: r.ok, data: data }; });
    });
  }

  /* ---------------------------------------- Carrito (igual que theme.js) */

  function sectionIds() {
    var ids = [];
    if (qs('[data-cart-drawer-content]')) ids.push('cart-drawer');
    if (qs('[data-cart-content]')) ids.push('main-cart');
    return ids.join(',');
  }

  function sectionsUrl() { return window.location.pathname + window.location.search; }

  function sectionsPayload(body) {
    var ids = sectionIds();
    if (ids) {
      body.sections = ids;
      body.sections_url = sectionsUrl();
    }
    return body;
  }

  function swap(doc, selector) {
    var fresh = doc.querySelector(selector);
    var current = qs(selector);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function syncCount() {
    var source = qs('[data-cart-drawer-count]');
    if (!source) return;
    var count = parseInt(source.getAttribute('data-cart-drawer-count'), 10);
    if (isNaN(count)) return;
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }

  function renderSections(sections) {
    if (!sections) return refresh();
    Object.keys(sections).forEach(function (key) {
      if (typeof sections[key] !== 'string') return;
      var doc = new DOMParser().parseFromString(sections[key], 'text/html');
      if (key === 'cart-drawer') swap(doc, '[data-cart-drawer-content]');
      if (key === 'main-cart') swap(doc, '[data-cart-content]');
    });
    syncCount();
  }

  function refresh() {
    var ids = sectionIds();
    if (!ids) return Promise.resolve();
    var url = sectionsUrl();
    return fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + ids, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) { if (s) renderSections(s); })
      .catch(function () {});
  }

  function setMessage(message) {
    qsa('[data-cart-error]').forEach(function (el) { el.textContent = message || ''; el.hidden = !message; });
  }

  var T = { render: renderSections, refresh: refresh, setMessage: setMessage };

  /* ------------------------------------------------------ Relevancia */

  var CATEGORIES = [
    ['top', /^(blusa|top|body|camisa|camiseta|playera|t-?shirt|thirt|shirt|corset|crop|chaleco|su[eé]ter|sweater|polo)/],
    ['bottom', /^(pantal[oó]n|pants?|jeans?|falda|short|skort|bermuda|legging)/],
    ['outer', /^(jacket|chamarra|blazer|abrigo|saco|coat|trench|cardigan|kimono|chaqueta)/],
    ['full', /^(vestido|dress|set|conjunto|jumper|jumpsuit|enterizo|mono|overol)/],
    ['shoes', /^(bota|botin|tenis|zapat|sandalia|tac[oó]n|heel|mule|flat)/],
    ['acc', /^(bolsa|bag|cintur[oó]n|collar|arete|lentes|gorra|cartera|pulsera|mascada)/]
  ];
  var COMPLEMENTS = {
    top: ['bottom', 'outer', 'acc', 'shoes'],
    bottom: ['top', 'outer', 'shoes', 'acc'],
    full: ['outer', 'shoes', 'acc'],
    outer: ['top', 'bottom', 'full'],
    shoes: ['acc', 'full', 'bottom'],
    acc: ['full', 'top', 'bottom']
  };

  function category(title) {
    var t = String(title || '').trim().toLowerCase();
    for (var i = 0; i < CATEGORIES.length; i++) if (CATEGORIES[i][1].test(t)) return CATEGORIES[i][0];
    return null;
  }

  function fetchRecs(productId, intent) {
    var key = productId + ':' + intent;
    if (!cache[key]) {
      cache[key] = fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return cache[key];
  }

  function minAvailable(p) {
    var min = null;
    (p.variants || []).forEach(function (v) {
      if (v.available && (min === null || v.price < min)) min = v.price;
    });
    return min;
  }

  function pickRecs(state) {
    var inCart = {};
    state.productIds.forEach(function (id) { inCart[id] = true; });

    var wanted = {};
    state.titles.forEach(function (t) {
      (COMPLEMENTS[category(t)] || []).forEach(function (c) { wanted[c] = true; });
    });

    var sources = [];
    var seen = {};
    state.productIds.forEach(function (id) {
      if (seen[id] || sources.length >= 3) return;
      seen[id] = true;
      sources.push(id);
    });

    var jobs = [];
    sources.forEach(function (id) {
      jobs.push(fetchRecs(id, 'complementary').then(function (list) { return { intent: 'complementary', list: list }; }));
      jobs.push(fetchRecs(id, 'related').then(function (list) { return { intent: 'related', list: list }; }));
    });

    return Promise.all(jobs).then(function (results) {
      var pool = {};
      results.forEach(function (res) {
        res.list.forEach(function (p, index) {
          if (!p || !p.available || inCart[p.id]) return;
          var min = minAvailable(p);
          if (min === null) return;
          var c = pool[p.id] || (pool[p.id] = { p: p, min: min, score: 0, rank: 99 });
          c.score += res.intent === 'complementary' ? 3 : 1;
          c.rank = Math.min(c.rank, index);
        });
      });

      var remaining = state.goal - state.subtotal;
      var list = Object.keys(pool).map(function (k) {
        var c = pool[k];
        if (wanted[category(c.p.title)]) c.score += 2;
        c.reaches = remaining > 0 && c.min >= remaining;
        return c;
      });

      // 1) más relevante; 2) entre igual de relevantes, el que alcanza el mínimo
      // con menor gasto; 3) si ninguno alcanza, el que más acerca; 4) orden de Shopify.
      list.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        if (a.reaches !== b.reaches) return a.reaches ? -1 : 1;
        if (a.reaches) return a.min - b.min;
        if (a.min !== b.min) return b.min - a.min;
        return a.rank - b.rank;
      });

      return list.slice(0, 3);
    });
  }

  /* ------------------------------------------------------ Tarjetas */

  function imageUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function hintFor(price, state) {
    if (state.hasDiscount) return '';
    var remaining = state.goal - state.subtotal;
    if (remaining <= 0) return '';
    if (price >= remaining) return 'Agrega este producto y consigue envío gratis.';
    return 'Con este producto te faltarían ' + money(remaining - price, state) + ' para envío gratis.';
  }

  function cardHTML(c, index, state, compact) {
    var p = c.p;
    var defaultOnly = isDefaultOnly(p.options);
    var prices = (p.variants || []).filter(function (v) { return v.available; }).map(function (v) { return v.price; });
    var varies = Math.min.apply(null, prices) !== Math.max.apply(null, prices);
    var priceText = (varies ? 'Desde ' : '') + money(c.min, state);
    var url = p.url || (root + 'products/' + p.handle);
    var img = p.featured_image || (p.images && p.images[0]) || '';

    var options = '';
    if (!defaultOnly) {
      p.options.forEach(function (opt, oi) {
        var name = typeof opt === 'string' ? opt : opt.name;
        var values = typeof opt === 'string' ? [] : opt.values;
        options += '<div class="rec-opt" data-rec-option="' + oi + '"><span class="rec-opt__label">' + esc(optionLabel(name)) + '</span><div class="rec-opt__values">';
        values.forEach(function (val) {
          options += '<button type="button" class="rec-opt__value" data-value="' + esc(val) + '" aria-pressed="false">' + esc(val) + '</button>';
        });
        options += '</div></div>';
      });
    }

    var hint = varies ? '' : hintFor(c.min, state); // con precio único el aviso es exacto

    return '' +
      '<article class="rec-card' + (index === 0 && !compact ? ' rec-card--main' : '') + '" data-rec data-product-id="' + p.id + '" data-position="' + (index + 1) + '">' +
        '<a class="rec-card__media" href="' + esc(url) + '" data-rec-link>' +
          (img ? '<img src="' + esc(imageUrl(img, 200)) + '" alt="' + esc(p.title) + '" width="200" height="267" loading="lazy">' : '') +
        '</a>' +
        '<div class="rec-card__info">' +
          '<a class="rec-card__title" href="' + esc(url) + '" data-rec-link>' + esc(p.title) + '</a>' +
          '<span class="rec-card__price" data-rec-price>' + priceText + '</span>' +
          (compact ? '' : '<p class="rec-card__hint" data-rec-hint' + (hint ? '' : ' hidden') + '>' + esc(hint) + '</p>') +
          options +
          '<button type="button" class="btn rec-card__add" data-rec-add' + (defaultOnly ? '' : ' disabled aria-disabled="true"') + '>' +
            (defaultOnly ? 'Agregar a mi pedido' : 'Elige tu ' + esc(optionLabel(typeof p.options[0] === 'string' ? p.options[0] : p.options[0].name).toLowerCase())) +
          '</button>' +
          '<p class="rec-card__error" data-rec-error role="alert" hidden></p>' +
        '</div>' +
      '</article>';
  }

  function selectedVariant(card, product) {
    var groups = qsa('[data-rec-option]', card);
    if (!groups.length) {
      return (product.variants || []).filter(function (v) { return v.available; })[0] || null;
    }
    var chosen = groups.map(function (g) {
      var b = qs('.rec-opt__value[aria-pressed="true"]', g);
      return b ? b.getAttribute('data-value') : null;
    });
    if (chosen.indexOf(null) !== -1) return undefined; // falta elegir
    return (product.variants || []).filter(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    })[0] || null;
  }

  function paintOptions(card, product) {
    var groups = qsa('[data-rec-option]', card);
    var chosen = groups.map(function (g) {
      var b = qs('.rec-opt__value[aria-pressed="true"]', g);
      return b ? b.getAttribute('data-value') : null;
    });
    groups.forEach(function (g, gi) {
      qsa('.rec-opt__value', g).forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        var ok = (product.variants || []).some(function (v) {
          if (!v.available || v.options[gi] !== val) return false;
          return chosen.every(function (c, ci) { return ci === gi || c === null || v.options[ci] === c; });
        });
        btn.disabled = !ok;
        btn.classList.toggle('is-unavailable', !ok);
        btn.setAttribute('aria-label', val + (ok ? '' : ' (agotado)'));
        if (!ok && btn.getAttribute('aria-pressed') === 'true') btn.setAttribute('aria-pressed', 'false');
      });
    });
  }

  function updateCard(card, product, state) {
    paintOptions(card, product);
    var v = selectedVariant(card, product);
    var add = qs('[data-rec-add]', card);
    var hint = qs('[data-rec-hint]', card);
    var price = qs('[data-rec-price]', card);
    if (v === undefined) {
      add.disabled = true;
      add.setAttribute('aria-disabled', 'true');
      return;
    }
    if (!v || !v.available) {
      add.disabled = true;
      add.setAttribute('aria-disabled', 'true');
      add.textContent = 'Agotado';
      return;
    }
    add.disabled = false;
    add.removeAttribute('aria-disabled');
    add.textContent = 'Agregar a mi pedido';
    if (price) price.textContent = money(v.price, state);
    if (hint) {
      var h = hintFor(v.price, state);
      hint.textContent = h;
      hint.hidden = !h;
    }
  }

  function bindCard(card, product, state, context) {
    card.addEventListener('click', function (event) {
      var link = event.target.closest('[data-rec-link]');
      if (link) {
        publish('trada_rec_click', { product_id: product.id, position: +card.getAttribute('data-position'), context: context });
        return;
      }

      var val = event.target.closest('.rec-opt__value');
      if (val && !val.disabled) {
        var group = val.closest('[data-rec-option]');
        qsa('.rec-opt__value', group).forEach(function (b) { b.setAttribute('aria-pressed', b === val ? 'true' : 'false'); });
        qs('[data-rec-error]', card).hidden = true;
        updateCard(card, product, state);
        return;
      }

      var add = event.target.closest('[data-rec-add]');
      if (!add || add.disabled || busy) return;
      var v = selectedVariant(card, product);
      if (!v || !v.available) return;

      busy = true;
      add.disabled = true;
      add.textContent = 'Agregando…';
      var err = qs('[data-rec-error]', card);
      err.hidden = true;

      postJSON('cart/add.js', sectionsPayload({
        items: [{ id: v.id, quantity: 1, properties: { _origen: ORIGIN } }]
      })).then(function (res) {
        if (!res.ok) {
          err.textContent = sentence(res.data.description || res.data.message, 'No se pudo agregar este producto') + ' Prueba otra talla o escríbenos por WhatsApp.';
          err.hidden = false;
          add.disabled = false;
          add.textContent = 'Agregar a mi pedido';
          return;
        }
        publish('trada_rec_add', { product_id: product.id, variant_id: v.id, position: +card.getAttribute('data-position'), context: context });
        add.textContent = '✓ Agregado';
        skipAddNotice = true;
        renderSections(res.data.sections);
        notice('✓ ' + product.title + ' se agregó a tu pedido');
      }).catch(function () {
        err.textContent = 'No se pudo agregar. Revisa tu conexión e intenta de nuevo.';
        err.hidden = false;
        add.disabled = false;
        add.textContent = 'Agregar a mi pedido';
      }).then(function () { busy = false; });
    });
  }

  function trackView(container, picks, context) {
    var ids = picks.map(function (c) { return c.p.id; }).join(',');
    var key = context + ':' + ids;
    if (viewedSets[key]) return;

    // Con envío gratis las recomendaciones van plegadas: solo cuentan si se abren.
    var fold = qs('details', container);
    if (fold) {
      fold.addEventListener('toggle', function () {
        if (!fold.open || viewedSets[key]) return;
        viewedSets[key] = true;
        publish('trada_rec_view', { product_ids: picks.map(function (c) { return c.p.id; }), context: context });
      });
      return;
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || viewedSets[key]) return;
        viewedSets[key] = true;
        publish('trada_rec_view', { product_ids: picks.map(function (c) { return c.p.id; }), context: context });
        io.disconnect();
      });
    }, { threshold: 0.5 });
    io.observe(container);
  }

  function renderRecs(scope) {
    var container = qs('[data-cart-recs]', scope);
    var state = readState(scope);
    if (!container || !state || !state.eligible || !state.productIds.length) return;

    var token = String(Date.now()) + Math.random();
    container.setAttribute('data-token', token);

    pickRecs(state).then(function (picks) {
      if (container.getAttribute('data-token') !== token || !document.contains(container)) return;
      if (!picks.length) { container.hidden = true; return; }

      var complete = state.goal - state.subtotal <= 0 && !state.hasDiscount;
      var html;
      if (complete) {
        picks = picks.slice(0, 2);
        html = '<details class="cart-recs__more"><summary>¿Algo más para tu look?</summary><div class="cart-recs__list">' +
          picks.map(function (c, i) { return cardHTML(c, i, state, true); }).join('') + '</div></details>';
      } else {
        html = '<p class="cart-recs__title">' + (state.hasDiscount ? 'Completa tu look' : 'Completa tu look y consigue envío gratis') + '</p><div class="cart-recs__list">' +
          picks.map(function (c, i) { return cardHTML(c, i, state, false); }).join('') + '</div>';
      }
      container.innerHTML = html;
      container.hidden = false;

      qsa('[data-rec]', container).forEach(function (card, i) {
        bindCard(card, picks[i].p, state, state.context);
        if (qsa('[data-rec-option]', card).length) paintOptions(card, picks[i].p);
      });
      trackView(container, picks, state.context);
    });
  }

  /* ------------------------------------------- Cambiar talla/color en línea */

  function lineData(wrap) {
    try { return JSON.parse(qs('[data-line-variant-json]', wrap).textContent); } catch (e) { return null; }
  }

  function buildPanel(wrap) {
    var data = lineData(wrap);
    var panel = qs('[data-line-variant-panel]', wrap);
    if (!data || !panel) return;
    var currentId = +wrap.getAttribute('data-variant-id');
    var current = data.variants.filter(function (v) { return v.id === currentId; })[0];

    var html = '';
    data.options.forEach(function (opt, oi) {
      html += '<label class="line-variant__field"><span>' + esc(optionLabel(opt.name)) + '</span><select data-opt="' + oi + '">';
      opt.values.forEach(function (val) {
        html += '<option value="' + esc(val) + '"' + (current && current.options[oi] === val ? ' selected' : '') + '>' + esc(val) + '</option>';
      });
      html += '</select></label>';
    });
    html += '<p class="line-variant__status" data-line-status></p>' +
      '<div class="line-variant__actions"><button type="button" class="btn line-variant__save" data-line-save disabled>Actualizar</button>' +
      '<button type="button" class="line-variant__cancel" data-line-cancel>Cancelar</button></div>';
    panel.innerHTML = html;
    paintLine(wrap, data);
  }

  function chosenLineVariant(wrap, data) {
    var chosen = qsa('select[data-opt]', wrap).map(function (s) { return s.value; });
    return data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    })[0] || null;
  }

  function paintLine(wrap, data) {
    var selects = qsa('select[data-opt]', wrap);
    var chosen = selects.map(function (s) { return s.value; });
    selects.forEach(function (sel, si) {
      qsa('option', sel).forEach(function (o) {
        var ok = data.variants.some(function (v) {
          return v.available && v.options[si] === o.value &&
            chosen.every(function (c, ci) { return ci === si || v.options[ci] === c; });
        });
        o.textContent = o.value + (ok ? '' : ' — agotado');
        o.disabled = !ok && !o.selected;
      });
    });

    var v = chosenLineVariant(wrap, data);
    var save = qs('[data-line-save]', wrap);
    var status = qs('[data-line-status]', wrap);
    var currentId = +wrap.getAttribute('data-variant-id');
    var state = readState(wrap.closest('[data-cart-drawer-content], [data-cart-content]') || document);

    if (!v) { save.disabled = true; status.textContent = 'Esa combinación no existe.'; return; }
    if (v.id === currentId) { save.disabled = true; status.textContent = ''; return; }
    if (!v.available) { save.disabled = true; status.textContent = 'Agotado en esta combinación.'; return; }
    save.disabled = false;
    status.textContent = 'Disponible · ' + money(v.price, state);
  }

  function changeVariant(wrap) {
    var data = lineData(wrap);
    var v = data && chosenLineVariant(wrap, data);
    if (!v || !v.available || busy) return;
    var key = wrap.getAttribute('data-line-key');
    var qty = +wrap.getAttribute('data-quantity') || 1;
    var props = data.properties && typeof data.properties === 'object' && !Array.isArray(data.properties) ? data.properties : {};
    var save = qs('[data-line-save]', wrap);

    busy = true;
    save.disabled = true;
    save.textContent = 'Actualizando…';

    // 1) agregar la nueva variante; 2) solo si funcionó, quitar la original.
    postJSON('cart/add.js', { items: [{ id: v.id, quantity: qty, properties: props }] })
      .then(function (res) {
        if (!res.ok) {
          var msg = 'No pudimos cambiar a ' + v.options.join(' / ') + ': ' +
            sentence(res.data.description || res.data.message, 'sin disponibilidad') +
            ' Tu artículo original sigue en el carrito. Si necesitas ayuda, escríbenos por WhatsApp.';
          return T.refresh().then(function () { T.setMessage(msg); });
        }
        return postJSON('cart/change.js', sectionsPayload({ id: key, quantity: 0 })).then(function (rem) {
          if (!rem.ok) {
            return T.refresh().then(function () {
              T.setMessage('Agregamos la nueva talla, pero no pudimos quitar la anterior. Elimínala desde el carrito.');
            });
          }
          T.render(rem.data.sections);
          notice('✓ Actualizado a ' + v.options.join(' / '));
        });
      })
      .catch(function () {
        return T.refresh().then(function () {
          T.setMessage('No se pudo cambiar la talla por un problema de conexión. Tu artículo original sigue en el carrito.');
        });
      })
      .then(function () { busy = false; });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-line-variant-toggle]');
    if (toggle) {
      var wrap = toggle.closest('[data-line-variant]');
      var panel = qs('[data-line-variant-panel]', wrap);
      var open = panel.hidden;
      if (open) buildPanel(wrap);
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var cancel = event.target.closest('[data-line-cancel]');
    if (cancel) {
      var w = cancel.closest('[data-line-variant]');
      qs('[data-line-variant-panel]', w).hidden = true;
      qs('[data-line-variant-toggle]', w).setAttribute('aria-expanded', 'false');
      return;
    }
    var save = event.target.closest('[data-line-save]');
    if (save && !save.disabled) changeVariant(save.closest('[data-line-variant]'));
  });

  document.addEventListener('change', function (event) {
    var sel = event.target.closest('select[data-opt]');
    if (!sel) return;
    var wrap = sel.closest('[data-line-variant]');
    paintLine(wrap, lineData(wrap));
  });

  /* ------------------------------- Botón de pago: un solo envío por clic */

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    var form = event.target;
    if (form.getAttribute('data-submitting') === 'true') { event.preventDefault(); return; }
    form.setAttribute('data-submitting', 'true');
    qsa('[data-checkout-button]').forEach(function (b) { b.classList.add('is-loading'); });
    setTimeout(function () {
      form.removeAttribute('data-submitting');
      qsa('[data-checkout-button]').forEach(function (b) { b.classList.remove('is-loading'); });
    }, 8000);
  });

  // Al volver con "atrás" desde el checkout, el botón queda usable.
  window.addEventListener('pageshow', function () {
    qsa('form[data-submitting]').forEach(function (f) { f.removeAttribute('data-submitting'); });
    qsa('[data-checkout-button]').forEach(function (b) { b.classList.remove('is-loading'); });
  });

  /* ------------------------------------------------------- Arranque */

  function renderAll() {
    var drawer = qs('#CartDrawer');
    if (drawer && drawer.classList.contains('is-open')) renderRecs(qs('[data-cart-drawer-content]'));
    var page = qs('[data-cart-content]');
    if (page) renderRecs(page);
  }

  /* ---- Doble clic en "Añadir al carrito" de la ficha: se ignora el segundo envío */

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (form.getAttribute('data-busy') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    form.setAttribute('data-busy', 'true');
    setTimeout(function () { form.removeAttribute('data-busy'); }, 2500);
  }, true);

  /* ---- Re-render del carrito (theme.js o este archivo): recalcular todo */

  var skipAddNotice = false;
  var lastCount = null;

  function currentCount() {
    var el = qs('[data-cart-drawer-count]');
    return el ? parseInt(el.getAttribute('data-cart-drawer-count'), 10) : null;
  }

  var timer = null;
  function onCartChanged() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var count = currentCount();
      var drawer = qs('#CartDrawer');
      if (lastCount !== null && count > lastCount && !skipAddNotice && drawer && drawer.classList.contains('is-open')) {
        notice('✓ Agregado a tu pedido');
      }
      skipAddNotice = false;
      lastCount = count;
      qsa('form[action*="/cart/add"][data-busy]').forEach(function (f) { f.removeAttribute('data-busy'); });
      renderAll();
    }, 30);
  }

  if ('MutationObserver' in window) {
    ['[data-cart-drawer-content]', '[data-cart-content]'].forEach(function (sel) {
      var el = qs(sel);
      if (el) new MutationObserver(onCartChanged).observe(el, { childList: true });
    });
    var drawerEl = qs('#CartDrawer');
    if (drawerEl) {
      new MutationObserver(function () {
        if (drawerEl.classList.contains('is-open')) renderRecs(qs('[data-cart-drawer-content]'));
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }
  }

  lastCount = currentCount();
  renderAll();
})();